__turbopack_context__.v({
  "actions": "EmailVerificationBanner-module-scss-module__GPFauq__actions",
  "banner": "EmailVerificationBanner-module-scss-module__GPFauq__banner",
  "copyLine": "EmailVerificationBanner-module-scss-module__GPFauq__copyLine",
  "email": "EmailVerificationBanner-module-scss-module__GPFauq__email",
  "emailLabel": "EmailVerificationBanner-module-scss-module__GPFauq__emailLabel",
  "headline": "EmailVerificationBanner-module-scss-module__GPFauq__headline",
  "icon": "EmailVerificationBanner-module-scss-module__GPFauq__icon",
  "main": "EmailVerificationBanner-module-scss-module__GPFauq__main",
  "verifyCta": "EmailVerificationBanner-module-scss-module__GPFauq__verifyCta",
  "verifyCtaDivider": "EmailVerificationBanner-module-scss-module__GPFauq__verifyCtaDivider",
  "verifyCtaLabel": "EmailVerificationBanner-module-scss-module__GPFauq__verifyCtaLabel",
  "verifyCtaStatus": "EmailVerificationBanner-module-scss-module__GPFauq__verifyCtaStatus",
});
